import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";

/**
 * The filter above a directory listing.
 *
 * Distinct from `AdminPageSearch` — that one navigates between administrative
 * pages, this one narrows the rows on the page you are already on. Two fields
 * that look alike doing different things is a real hazard, which is why this one
 * carries the column names it searches in its label rather than a bare "Search".
 */
export const DirectoryFilter = ({
  value,
  label,
  onChange,
}: {
  value: string;
  label: string;
  onChange: (value: string) => void;
}) => (
  <TextField
    size="small"
    value={value}
    label={label}
    onChange={(event) => {
      onChange(event.target.value);
    }}
    sx={{ maxWidth: 420 }}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      },
    }}
  />
);
